import React from 'react';
import Modal from '../../../../../components/Modal';
import Table from '../../../../../components/table/Table';
import { columns } from './columns';

const BrandProductListModal = (props) => {
  const { isOpen, data, getList, closeModal, getProductSubCategoryList } = props;
  const { list, pagination } = data.listData;

  return (
    <Modal
      title="전체 상품"
      isOpen={isOpen}
      width={1500}
      height={600}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="brand-product-list-modal">
        <Table
          className="brand-product-list"
          emptyText="브랜드의 상품이 없습니다."
          data={list}
          pagination={pagination}
          getList={getList}
          showPagination
          columns={() =>
            columns({
              getProductSubCategoryList,
              pageNum: pagination.pageNum,
              pageSize: pagination.pageSize,
            })
          }
        />
      </div>
    </Modal>
  );
};

export default BrandProductListModal;
